import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface GroupVoteAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BENEFITS = [
  "Vote créé en 30 secondes",
  "Tes invités n'ont pas besoin de compte",
  "Trouve le créneau qui convient à tout le monde",
];

const GroupVoteAuthModal = ({ isOpen, onClose }: GroupVoteAuthModalProps) => {
  const navigate = useNavigate();

  const handleSignup = () => {
    onClose();
    navigate('/auth?tab=signup');
  };

  const handleLogin = () => {
    onClose();
    navigate('/auth?tab=login');
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="mx-auto mb-3 w-14 h-14 rounded-full bg-brand-primary/10 flex items-center justify-center text-3xl">
            🗳️
          </div>
          <DialogTitle className="text-center text-[20px]">
            Organise ton vote de groupe
          </DialogTitle>
          <DialogDescription className="text-center text-[14px]">
            Crée un compte gratuit pour commencer. Tes amis n'auront pas besoin de s'inscrire.
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-2.5 my-1">
          {BENEFITS.map((benefit) => (
            <li key={benefit} className="flex items-start gap-2.5 text-[13px] text-brand-text">
              <span className="mt-0.5 w-5 h-5 rounded-full bg-brand-success flex items-center justify-center text-white text-[10px] font-bold shrink-0">
                ✓
              </span>
              {benefit}
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-2.5 pt-2">
          <Button
            onClick={handleSignup}
            className="w-full bg-brand-primary hover:bg-brand-primary-600 text-white"
          >
            Créer un compte gratuit
          </Button>
          <Button
            onClick={handleLogin}
            variant="outline"
            className="w-full"
          >
            J'ai déjà un compte
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GroupVoteAuthModal;
